import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import App from '../app.js';
import ScrollMagic from 'scrollmagic';
var Hero = function(){
	var $section = $("#Hero"),
			$logo,
			scrollMagicController = App.getScrollMagicController(),
			tween,
			scene;
	if( $section.length < 1 ) return false;

	$logo = $section.find('.js-logo  svg');

	// imagesLoaded($section[0], sectionLoaded);

	// $section.on('load', sectionLoaded, true);
	$section[0].addEventListener('load', sectionLoaded, true);

	function sectionLoaded(event) {
		$section.addClass('is-active');
	}

	function createScrollMagic() {

		new ScrollMagic.Scene({
				triggerElement: $section[0],
				triggerHook: "onEnter",
				// triggerHook: 0.5,
				duration: "200%"
			})
			.setTween($logo[0], {y: "25%", ease: Linear.easeNone})
			// .addIndicators()
			.addTo(scrollMagicController);

	}

	// createScrollMagic();

}

export default Hero();